import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'

import { SummaryChart as SummaryChart_ } from '../common/summary-chart'
import { SummaryChartChange } from '../common/summary-chart-change'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

export type DataEntry = [Date, BigNumber]

type SummaryChartProps = ClassNameProps & {
  change: BigNumber
  changePercentage: number
  data: Array<DataEntry>
}

export const SummaryChart: React.FC<SummaryChartProps> = ({
  change,
  changePercentage,
  data,
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      <TimeFrame>{t('common.30d')}</TimeFrame>
      <Chart data={data} changePercentage={changePercentage} />
      <Change change={change} changePercentage={changePercentage} />
    </Root>
  )
}

const Root = styled.div`
  position: relative;
`

const Chart = styled(SummaryChart_)`
  height: 72px;
  position: relative;
`

const TimeFrame = styled(Typography).attrs({
  variant: 'description-bold',
  component: 'div',
})`
  text-align: center;
  color: rgba(255, 255, 255, 0.35);

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`

const Change = styled(SummaryChartChange)`
  position: absolute;
  bottom: 4px;

  left: 50%;
  transform: translateX(-50%);
`
